import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { NewPaymentMethodDialogContainer } from '@/features/billing/payment-methods/NewPaymentMethodDialog/NewPaymentMethodDialogContainer'
import { PaymentMethodSelectorDialogContainer } from '@/features/billing/payment-methods/PaymentMethodSelectorDialog/PaymentMethodSelectorDialogContainer'

/**
 * Inner component which requests the actual loading of the module.
 */
export default observer(function Inner() {
  const { billing } = useFeatures((r) => ({ billing: r.billing.internal() }))

  return (
    <>
      <NewPaymentMethodDialogContainer vm={billing.newPaymentMethodDialogVm} />
      <PaymentMethodSelectorDialogContainer
        vm={billing.paymentMethodSelectorDialogVm}
      />
    </>
  )
})
